module.exports = __webpack_public_path__ + "static/media/C++-(CPlusPlus).e5b135b0.svg";